export * from "./steps";
export * from "./api";
export * from "./analysis";
export * from "./posthog";

export { SECTOARE, SUBSECTOARE };

const SECTOARE = {
  "101": "Energie",
  "102": "Transport",
  "103": "Sectorul bancar",
  "104": "Infrastructuri ale pieței financiare",
  "105": "Sectorul sănătății",
  "106": "Apă potabilă",
  "107": "Ape uzate",
  "108": "Infrastructură digitală",
  "109": "Gestionarea serviciilor tic (business-to-business)",
  "110": "Administrație publică",
  "111": "Spațiu",
  "201": "Servicii poștale și de curierat",
  "202": "Gestionarea deșeurilor",
  "203": "Fabricarea, producția și distribuția de substanțe chimice",
  "204": "Producția, prelucrarea și/sau distribuția de alimente",
  "205": "Fabricare",
  "206": "Furnizori digitali",
  "207": "Cercetare",
} as const;

const SUBSECTOARE = {
  "1011": "Electricitate",
  "1012": "Încălzire centralizată și răcire centralizată",
  "1013": "Petrol",
  "1014": "Gaze",
  "1015": "Hidrogen",
  "1016": "Beneficiarii proiectelor finanțate din fonduri nerambursabile",
  "1021": "Transport aerian",
  "1022": "Transport feroviar",
  "1023": "Transport pe apă",
  "1024": "Transport rutier",
  "1025": "Transport public",
  "2051":
    "Fabricarea de dispozitive medicale și de dispozitive medicale pentru diagnostic in vitro",
  "2052": "Fabricarea computerelor și a produselor electronice și optice",
  "2053": "Fabricarea echipamentelor electrice",
  "2054": "Fabricarea altor mașini și echipamente n.c.a.",
  "2055": "Fabricarea autovehiculelor, remorcilor și semiremorcilor",
  "2056": "Fabricarea altor echipamente de transport",
} as const;
